import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import teksturtitle from './assets/home/rankytanktitle.png'

import Footer from './footer'
import { SupportForm } from './SupportForm'

function RankyTankSupport() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div className="tekstur" style={{ flex: 1, marginTop: '1vw' }}>
          <a href="/rankytank">
            <img className="rankytanktitle2" src={teksturtitle} />
          </a>
          <div className="rankytanksubtitleprivacy" style={{ }}>
            Support
          </div>

          <SupportForm lang="us" appType="rankytank" />          
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default RankyTankSupport
